import { useHistory } from 'react-router-dom'

import { navigateTo } from 'components/common/navigation'
import { ROUTE_SUPPORT } from 'components/common/helpers/Paths'
import { buildRequestURL } from 'components/common/api'

/**
 * Simple Account Delete Notice component. Used to display a notice to the user, letting them
 * know that they have an account and that they can delete it.
 * See https://developer.apple.com/support/offering-account-deletion-in-your-app/ for more info
 */
export default function AccountDeleteNotice({ className = '' }) {
  const history = useHistory()
  const url = buildRequestURL(ROUTE_SUPPORT, { requestType: 'delete' })

  return (
    <p className='mt-3'>
      <small>
        If you wish to delete your account, along with associated personal data,{' '}
        <span
          className='support-link green'
          onClick={_ => navigateTo(url, history)}
        >
          submit a delete request
        </span>{' '}
        and our support team will remove your account. Please allow up to 7 days
        for account and data deletion.
      </small>
    </p>
  )
}
